import React from 'react';
import { withStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import DisabledIcon from '@mui/icons-material/HideSource';
import { useStyles } from './NewItemButton.styles';
import { Grid } from '@material-ui/core';

const AddSessionItemButton = withStyles(() => ({
  root: {
    color: '#3C419A',
    boxShadow: 'none',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
    border: 'solid 1px #3C419A',
    backgroundColor: 'rgba(202, 202, 252, 0.3)',
    padding: '5px 0px 5px 10px',
    margin: '10px',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
}))(Button);

interface NewItemButtonProps {
  caption: string;
  disabled?: boolean;
  onClick: () => void;
}

const NewItemButton: React.FC<NewItemButtonProps> = (props) => {
  const classes = useStyles();

  return (
    <Grid container justifyContent="flex-end" alignItems="center" style={{ padding: '10px' }}>
      <AddSessionItemButton
        className={classes.addSessionItemButton}
        variant="contained"
        startIcon={
          props.disabled ? (
            <DisabledIcon
              style={{
                color: '#81818D',
              }}
            />
          ) : null
        }
        endIcon={
          <NavigateNextIcon
            className={classes.addSessionItemButtonIcon}
            style={{ color: props.disabled ? 'rgba(0, 0, 0, 0.26)' : '#3C419A' }}
          />
        }
        disabled={props.disabled}
        onClick={props.onClick}
      >
        {props.caption}
      </AddSessionItemButton>
    </Grid>
  );
};

export default NewItemButton;
